module.exports = __webpack_public_path__ + "static/media/YF79_0.2c7a74b4.jpg";